import ProductItemPresenter from "../../products-list/presenter/product-item.js";
import ProductQuantityPresenter from "../../product-quantity/presenter/product-quantity.js";

import ProductTitleView from "../view/product-title.js";

import {
  declinationNumber
} from "../../../utils/declination-number.js";

import {
  formatNumber
} from "../../../utils/format-number.js";

import {
  render,
  RenderPosition
} from "../../render/render.js";

import {
  debounce
} from "../../../utils/debounce.js";

import {
  PER_PALLET_UNIT_MEASURE,
  PER_PACKAGE_UNIT_MEASURE,
  PRICE_CURRENCY
} from "../lexicon.js";

import {
  LAYOUT_CHANGE_MEDIA_QUERY,
  defaultProductTitleModelData,
  ActionType
} from "../const.js";

export default class ProductTitle extends ProductItemPresenter {
  constructor(element, id) {
    super(element, id);

    this._ItemView = ProductTitleView;


    this._itemModelData = Object.assign(
        {},
        this._itemModelData,
        defaultProductTitleModelData
    );

    this._productQuantityPresenter = null;
    this._handleWindowResize = this._handleWindowResize.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleProductQuantityObservation = this._handleProductQuantityObservation.bind(this);
  }

  init() {
    super.init();

    this._itemModel.changeData(Object.assign(
        {},
        this._itemModel.getData(),
        {
          itemId: this._itemView.getProductId(),
          price: this._itemView.getPrice(),
          oldPrice: this._itemView.getOldPrice(),
          quantity: this._itemView.getQuantity(),
          perPallet: this._itemView.getPerPallet(),
          volume: this._itemView.getVolume(),
          totalPerPallet: this._itemView.getTotalPerPallet(),
          totalVolume: this._itemView.getTotalVolume(),
          totalArea: this._itemView.getTotalArea(),
          totalCurrentPrice: this._itemView.getTotalCurrentPrice(),
          totalOldPrice: this._itemView.getTotalOldPrice(),
          packageItems: this._itemView.getPackageItems(),
          packageM2: this._itemView.getPackageM2()
        }
    ), ActionType.INIT);
    this._itemModel.addObserver(this._handleChangeData);

    this._productQuantityPresenter = new ProductQuantityPresenter(
        this._itemView.getQuantityElement(),
        null,
        this._itemView.getProductId()
    );

    if (this._itemModel.getData().initAddToCartTrigger) {
      this._productQuantityPresenter.addObserver(this._addToCartPresenter.getProductQuantityObservationHandler());
    }

    this._productQuantityPresenter.init();

    this._changeLayout();

    window.addEventListener(`resize`, debounce(this._handleWindowResize));

    this._productQuantityPresenter.addObserver(this._handleProductQuantityObservation);
  }

  _changeLayout() {
    const modelData = this._itemModel.getData();
    const isLayoutChanged = modelData.isLayoutChanged;

    if (window.matchMedia(LAYOUT_CHANGE_MEDIA_QUERY).matches && !isLayoutChanged) {
      this._itemModel.changeData(Object.assign(
          {},
          this._itemModel.getData(),
          {
            isLayoutChanged: !isLayoutChanged
          }
      ), ActionType.CHANGE_LAYOUT);
    }

    if (!window.matchMedia(LAYOUT_CHANGE_MEDIA_QUERY).matches && isLayoutChanged) {
      this._itemModel.changeData(Object.assign(
          {},
          this._itemModel.getData(),
          {
            isLayoutChanged: !isLayoutChanged
          }
      ), ActionType.RESET_LAYOUT);
    }
  }

  _processLayoutChange() {
    render(
        this._itemView.getProductInfoContainerElement(),
        this._itemView.getFeaturesListElement()
    );
  }

  _processLayoutReset() {
    render(
        this._itemView.getProductFeaturesElement(),
        this._itemView.getFeaturesListElement(),
        RenderPosition.AFTERBEGIN
    );
  }

  _processChangeQuantity() {
    const {
      totalPerPallet,
      totalVolume,
      totalCurrentPrice,
      totalOldPrice,
      totalPackageItems,
      totalPackageM2
    } = this._itemModel.getData();

    if (totalPerPallet > 0) {
      this._itemView.setTotalPerPallet(`${totalPerPallet.toFixed(0)}\u00A0${declinationNumber(totalPerPallet, PER_PALLET_UNIT_MEASURE)}`);
      this._itemView.setTotalVolume(totalVolume);
    } else {
      if (totalPackageM2 > 0) {
        this._itemView.setTotalArea(totalPackageM2);
      }

      if (totalPackageItems > 0) {
        this._itemView.setTotalPackageItems(`${totalPackageItems}\u00A0${declinationNumber(totalPackageItems, PER_PACKAGE_UNIT_MEASURE)}`);
      }
    }

    this._itemView.setTotalCurrentPrice(`${formatNumber(totalCurrentPrice, 2, `,`, `\u00A0`)}\u00A0${PRICE_CURRENCY}`);

    if (totalOldPrice) {
      this._itemView.setTotalOldPrice(`${formatNumber(totalOldPrice, 2, `,`, `\u00A0`)}\u00A0${PRICE_CURRENCY}`);
    }
  }

  _handleWindowResize() {
    this._changeLayout();
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.CHANGE_LAYOUT:
        this._processLayoutChange();
        break;
      case ActionType.RESET_LAYOUT:
        this._processLayoutReset();
        break;
    }
  }

  _handleProductQuantityObservation(action, payload) {
    switch (action) {
      case ActionType.ADD_QUANTITY:
      case ActionType.REMOVE_QUANTITY:
      case ActionType.INVALID_CHECK:
      case ActionType.BLUR:
      case ActionType.SUBMIT:
      case ActionType.CHANGE:
        this._itemModel.changeData(Object.assign(
            {},
            this._itemModel.getData(),
            {
              quantity: payload.quantity,
              totalPerPallet: payload.quantity * this._itemModel.getData().perPallet / payload.step,
              totalVolume: payload.quantity * this._itemModel.getData().volume / payload.step,
              totalCurrentPrice: payload.quantity * this._itemModel.getData().price,
              totalOldPrice: payload.quantity * this._itemModel.getData().oldPrice,
              totalPackageItems: payload.quantity * this._itemModel.getData().packageItems,
              totalPackageM2: payload.quantity * this._itemModel.getData().packageM2
            }
        ), action);

        this._processChangeQuantity();
        break;
    }
  }
}
